import { useQuery } from '@tanstack/react-query';
import { useLocation } from '@/shared/hooks/useLocation';
import { verificationApi } from '../api/verificationApi';
import { ivKeys } from '../queryKeys';

export function useWorklistMetrics() {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';

  const query = useQuery({
    queryKey: ivKeys.metrics(locationId),
    queryFn: () => verificationApi.getMetrics(locationId),
    enabled: !!locationId,
    // The worklist polls while checks run; keep the attention cards and
    // metric strip in step with it instead of showing counts from page load.
    refetchInterval: 10_000,
    refetchIntervalInBackground: false,
  });

  return { ...query, metrics: query.data ?? null, locationId };
}
